import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PreferenceService } from '../../../services/preference.service';
import { CryptoService } from '../../../services/crypto.service';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as fromFeature from '../../../my-features';

@Component({
  standalone: false,
  selector: 'app-used-device-history',
  templateUrl: './used-device-history.component.html',
  styleUrls: ['./used-device-history.component.css']
})
export class UsedDeviceHistoryComponent implements OnInit {
  private componentDestroyed = new Subject();
  docTable_cols: any[] = [
    { field: '', header: 'No.', width: '50', class: 'col-nowrap' },
    { field: 'Company', header: 'Company', width: '150', class: 'col-nowrap' },
    { field: 'MonthYear', header: 'Month/Year', width: '150', class: 'col-nowrap' },
    { field: 'DeviceUsage', header: 'Used Device', width: '150', class: 'col-nowrap' },
  ];
  getMspDeviceUsageParam = {
    otp: '',
    RegionId: 0,
    IsDetail: false,
  };
  docList =[];
  constructor( private _location: Location, public preferenceService: PreferenceService,
    private route: ActivatedRoute, private cryptoService: CryptoService, 
    private store: Store<fromStore.State> ) {
    const hashObj = JSON.parse(this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('hashObj')));
    const split_hashIds = hashObj.id.split(',');
    // 母公司只會有一個Id
    let regionId = parseInt(split_hashIds[0])
    if (split_hashIds.length > 1) {
      regionId = parseInt(split_hashIds[1])
    }

    this.getMspDeviceUsageParam = {
      ...this.getMspDeviceUsageParam,
      RegionId: regionId,
      ...(hashObj.isDistributor ? { IsDetail: true } : {}),
    };
    this.store.dispatch(new fromFeature.ReadMspDeviceUsage({ ...this.getMspDeviceUsageParam }));
    // Get Device Usage List
    this.store.select(fromStore.getMspDeviceUsage).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined && res.deviceUsage !== undefined && res.deviceUsage.length > 0 && res.region_dic.length > 0) {
        this.docList = res.deviceUsage;
      }
    });
  }

  ngOnInit() {
  }


  backClicked() {
    this._location.back();
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }
}
